// @core/api/endpoints/attachment/list_attachments.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAttachmentsResponse,
} from '../../../types/attachment';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/attachment';

/**
 * List attachments with filters
 * Returns a paginated list of attachments with extensive filtering options including type, MIME type, owner, date range, and processing status.
 */
export async function ListAttachments(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListAttachmentsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/attachments`;
  const requestOptions = options;
  return client.get<ListAttachmentsResponse>(requestPath, { ...requestOptions, params });
}
